import React, {useState}   from "react";
import { useSearchParams } from "react-router-dom";
import CompanyForm from "./CompanyForm";
import CompanySearch from "./CompanySearch";
import CompanyTable from "./CompanyTable";

const Company = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedData, setSelectedData] = useState(null);

  const searchParam = {
    searchCnd: searchParams.get("searchCnd") || "",
    searchWrd: searchParams.get("searchWrd") || "",
  };

  const handleSearch = (data) => {
    const newParams = new URLSearchParams();
    newParams.set("pageIndex", "1");
    if (data.searchCnd) newParams.set("searchCnd", data.searchCnd);
    if (data.searchWrd) newParams.set("searchWrd", data.searchWrd);
    setSearchParams(newParams);
  };

  // 목록 테이블에서 행 클릭 시
  const handleRowClick = (item) => {
    setSelectedData(item);
  };

  // 등록 / 수정 후 (저장 시) 처리: 선택 해제 후 목록 재조회를 위해 URLSearchParams 재설정
  const handleSaved = () => {
    setSelectedData(null);
    setSearchParams((prev) => new URLSearchParams(prev));
  };

  // 등록 / 수정 폼 추가 처리
  const handleAdd = () => {
    setSelectedData(null);
  }
  const resetSearchParams = () => {
    setSearchParams(new URLSearchParams());
  };

  return (
      <div className="contents-wrap">
        <div className="page-title-wrap">
          <h2><span className="icon-dot-circle"></span>업체 정보 관리</h2>
        </div>

        <div className="tab-cont-wrap">
          <div className="tab-cont-01 on">

          <CompanySearch 
            defaultValues={searchParam} 
            onSearch={handleSearch}
            onReset={resetSearchParams}
          />

            <div className="row-1">
              <section className="wp55 section-wrap">
                <CompanyTable
                  handleRowClick={handleRowClick}
                  selectedId={selectedData?.id}
                />
              </section>
              <section className="wp45">  
                <CompanyForm
                  selectedData={selectedData}
                  onSaved={handleSaved}
                  onAdd={handleAdd}
                />
              </section>  
            </div>
          </div>
        </div>
      </div>
  );
};

export {Company};
